<ng-container #institutionSelector></ng-container>
<div class="content">
  <div class="content__inner">
    <ng-container #productHeader></ng-container>
    <div class="pro-widgets">
      <ng-container #flexContainer></ng-container>
    </div>
    <ng-container #legend></ng-container>
  </div>
</div>

<div #dialog></div>
